import { LRUObjectCache } from "./lruObjectCache";

export class LRUStringCache<V> extends LRUObjectCache<string, V> {
  constructor(size: number) {
    super(size, (a, b) => a === b);
  }
}
